// Chequeo de roles sobre el profile (MOOV-5198). Los computeds de
// utils.mixin.js delegan acá; los componentes siguen usando isSuperAdmin etc.
export function hasRole(profile, ...roleNames) {
  // Sin perfil cargado (boot, pre-login) ningún rol: mismo resultado que post-carga
  // para quien no tiene el rol, sin el TypeError transitorio de siempre
  if (!profile || !profile.roles) {
    return false
  }
  return roleNames.some(name => profile.roles.findIndex(x => x.name === name) !== -1)
}
